import * as React from 'react';

import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

import {
  ACTIVITY_IDS_ARRAY,
  CLASSROOMS,
  UNIT_NAME,
  UNIT_TEMPLATE_ID,
  UNIT_TEMPLATE_NAME,
} from './assignmentFlowConstants';

interface LeavingModalProps {
  cancel: () => void;
}

const LeavingModal: React.FC<LeavingModalProps> = ({ cancel }) => {
  const { modalRef, } = useModalAccessibility(cancel)

  const leave = () => {
    window.localStorage.removeItem(UNIT_TEMPLATE_ID);
    window.localStorage.removeItem(UNIT_TEMPLATE_NAME);
    window.localStorage.removeItem(UNIT_NAME);
    window.localStorage.removeItem(ACTIVITY_IDS_ARRAY);
    window.localStorage.removeItem(CLASSROOMS);
    window.location.href = '/';
  };

  return (
    <div className="modal-container leave-class-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="leaveModalTitle"
        aria-modal="true"
        className="leave-class-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="leaveModalTitle">
            Leave without assigning?
          </h3>
        </div>
        <div className="leave-class-modal-text">
          <p>
            If you exit the assigning process now, you will not be able to resume your current progress.
            However, you can assign new content at any time.
          </p>
        </div>
        <div className="form-buttons">
          <button
            className="quill-button outlined grey medium focus-on-light"
            onClick={cancel}
            type="button"
          >
            Cancel
          </button>
          <button
            className="quill-button contained green medium focus-on-light"
            onClick={leave}
            type="button"
          >
            Go to dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeavingModal;
